import {LitElement, html} from 'lit';
import './cbar-places-item';

class CbarPlacesList extends LitElement{
  static get properties(){
    return {
      // items before formatting
      items: {
        type: Array,
      },
      imageShape: {
        type: String
      },
      lines: {
        type: Number
      },
      loading: {
        type: Boolean
      }
    }
  }

  constructor() {
    super();
    this.items = [];
    this.lines = 2;
    this.imageShape = "square"
    this.loading = false;
  }

  get items() {
    return this._items;
  }

  get lines(){
    return this._lines;
  }

  get imageShape(){
    return this._imageShape;
  }

  get loading (){
    return this._loading
  }

  set items(items) {
    this._items = items;
    this.requestUpdate();
  }

  set lines(lines){
    this._lines = lines;
    this.requestUpdate();
  }

  set imageShape(shape){
    this._imageShape = shape;
    this.requestUpdate();
  }

  set loading(loading){
    this._loading = loading;
    this.requestUpdate();
  }

  render() {
    return html`
      <style>
        cbar-places-list{
          background-color: var(--cbar-places-list-color, var(--cbar-sys-color-surface-container, #eeeeee));
        }
        cbar-places-item{
          border-bottom: 1px solid var(--cbar-sys-color-outline, rgba(0, 0, 0, 0.12));
          display: block;
        }
      </style>
      ${this.items.map(item => html`<cbar-places-item .id="${item.id}" .title="${item.title}" .type="${item.type}" .image="${item.image}" .description="${item.description}" .meta="${item.meta}" lines="${this.lines}" .extraInformation="${item.extraInformation}" .icon="${item.icon}" imageSizing="cover" imageShape="${this.imageShape}" ?showCheckbox="${item.showCheckbox}" ?checkboxChecked="${item.checked}" ?loading="${this.loading}"></cbar-places-item>`)}
    `;
  }
}
customElements.define('cbar-places-list', CbarPlacesList);